<template>
  <ets-header>
    <span class="title">{{ title }}</span>
    <span slot="subtitle">{{ subtitle }}</span>
    <template slot="tools">
      <slot />
      <div class="divider" />
      <button class="logout-button" @click="logout">
        Logout
      </button>
    </template>
  </ets-header>
</template>

<script>
export default {
  name: "LayoutHeader",
  props: {
    title: {
      type: String,
      required: false,
      default: ""
    },
    subtitle: {
      type: String,
      required: false,
      default: ""
    }
  },
  methods: {
    logout() {
      const schema = window.location.protocol;
      const host = process.env.VUE_APP_WEB_INTRANET;
      const url = `${schema}//${host}/logout`;
      window.location.href = url;
    }
  }
};
</script>

<style lang="scss" scoped>
.title {
  color: $color-grey;
  white-space: nowrap;
}
.logout-button {
  background-color: #1b4b88;
  color: white;
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.logout-button:hover {
  background-color: #0d2547; /* Un poco más oscuro al pasar el ratón */
}

.logout-button:active {
  background-color: #1a4580; /* Un poco más claro al hacer clic */
}
.divider {
  width: 1px;
  height: 24px;
  background-color: #ccc;
  margin: 0 8px;
}
</style>
